import { Typography } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import { NullableDateString } from '@superdispatch/dates';
import { ColorDynamic, Inline, Tag } from '@superdispatch/ui';
import { ReactElement } from 'react';
import { ResponsiveTooltip } from 'shared/ui/ResponsiveTooltip';
import { ratingTimeLeft } from './ShipperRatingUtils';

interface RatingWindowTooltipProps {
  children: ReactElement;
}

function RatingWindowTooltip({ children }: RatingWindowTooltipProps) {
  return (
    <ResponsiveTooltip
      title={
        <Typography>
          You can give ratings within 90 days
          <br /> of delivery or cancellation.
        </Typography>
      }
    >
      {children}
    </ResponsiveTooltip>
  );
}

interface ShipperRatingAvailableTimeLeftProps {
  date: NullableDateString;
}

export function ShipperRatingAvailableTimeLeft({
  date,
}: ShipperRatingAvailableTimeLeftProps) {
  const daysLeft = ratingTimeLeft(date);

  if (daysLeft >= 8) {
    return (
      <Inline verticalAlign="center" space="xxsmall">
        <Typography color="textSecondary">{daysLeft} days left</Typography>
        <RatingWindowTooltip>
          <Info fontSize="small" htmlColor={ColorDynamic.Dark100} />
        </RatingWindowTooltip>
      </Inline>
    );
  }

  return (
    <Tag variant="subtle" color="yellow">
      <Inline verticalAlign="center" space="xxsmall">
        {daysLeft === 1 ? (
          <Typography>Only 1 day left</Typography>
        ) : (
          <Typography>{daysLeft} days left</Typography>
        )}
        <RatingWindowTooltip>
          <Info fontSize="small" htmlColor={ColorDynamic.Yellow500} />
        </RatingWindowTooltip>
      </Inline>
    </Tag>
  );
}
